export const isPrimary = (comm) => comm.telecommunicationUseCode === 'Primary';
export const isAPhoneNumber = (comm) => comm.unformattedTelephoneNumber || comm.telephoneNumber;
export const isAnEmail = (comm) => !!comm.emailAddress;
export const hasLowerPreferenceOrder = (cur, prev) => prev?.preferenceOrder && cur.preferenceOrder && prev.preferenceOrder > cur.preferenceOrder;
